define('pages/help/help_page_view',[
  'backbone',
  'jquery',
  '_',

  'text!./help_page_template.html',
  'text!./help_page_content_template.html',
  'text!./help_page_video.html'

], function (Backbone, $, _, help_page_template, help_page_content_template, help_page_video) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (opts) {

      this.subViews = [];
      this.render();
      // this.renderVideo();
      this.renderContent();

    },

    template: _.template(help_page_template),
    content_template: _.template(help_page_content_template),
    help_page_video: _.template(help_page_video),
    subViews: [],

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderVideo: function() {
      this.$('.help-video').html(this.help_page_video());
    },

    renderContent: function () {
      this.$('.help-page-content').html(this.content_template());
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

